"use strict";
exports.__esModule = true;
exports.chart_scatter_data_Fill = {
  "name": "--pf-chart-scatter--data--Fill",
  "value": "#151515",
  "var": "var(--pf-chart-scatter--data--Fill, #151515)"
};
exports["default"] = exports.chart_scatter_data_Fill;